"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUS_CUSTOM_SUBJECT_TYPE_NAME = void 0;
exports.BUS_CUSTOM_SUBJECT_TYPE_NAME = 'cadstrom.bus';
//# sourceMappingURL=bus-subject.js.map